export enum NetworkState {
  PENDING = 'PENDING',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  CANCELED = 'CANCELED',
  NOT_STARTED = 'NOT_STARTED',
  AUTHENTICATED = 'AUTHENTICATED',
}
